// Types
import { SettingsLogItem } from "types/logs";
// Theme
// Constants
import { TABLE_DATE } from "consts";
// Helpers
import {
  dateTransform,
  getFullName,
  isShallowObject,
} from "helpers/dataHelpers";
import { getSettingsName, humanizePath } from "../helpers";

const objectToString = (obj: Record<string, any>): string => {
  if (obj === null || typeof obj !== "object" || Array.isArray(obj)) {
    throw new Error("Expected a shallow object");
  }

  return Object.entries(obj)
    .map(([key, value]) => {
      if (key === "count") return "";
      return `${humanizePath(key)}: ${value}`;
    })
    .join(", ");
};

const getParsedValue = (value: unknown) => {
  if (value === undefined || value === null) {
    return null;
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "boolean") {
    return value ? "Enabled" : "Disabled";
  }

  if (typeof value === "number") {
    return String(value);
  }

  if (typeof value !== "object") {
    return null;
  }

  if ("removed" in value) {
    if (Array.isArray(value?.removed)) {
      return value?.removed?.map(String).join(", ");
    }

    if (typeof value?.removed === "string") {
      return value?.removed;
    }

    return null;
  }

  if ("added" in value) {
    if (Array.isArray(value?.added)) {
      return value?.added?.map(String).join(", ");
    }

    if (typeof value?.added === "string") {
      return value?.added;
    }

    return null;
  }

  if (isShallowObject(value)) {
    return objectToString(value);
  }
};

export const columns = [
  {
    title: "Settings Name",
    dataIndex: "settingsName",
    key: "settingsName",
    width: "355px",
    render: (settingsName: string) => getSettingsName(settingsName),
  },
  {
    title: "Phone number",
    dataIndex: "userPhone",
    key: "userPhone",
  },
  {
    title: "User Name",
    dataIndex: "userFirstName",
    key: "userFirstName",
    render: (firstName: string, record: SettingsLogItem) =>
      getFullName({ firstName, lastName: record?.userLastName }),
  },
  {
    title: "Area label",
    dataIndex: "areaLabel",
    key: "areaLabel",
  },
  {
    title: "Initial value",
    dataIndex: "initialValue",
    key: "initialValue",
    render: (value: unknown) => getParsedValue(value),
  },
  {
    title: "Updated value",
    dataIndex: "updatedValue",
    key: "updatedValue",
    render: (value: unknown) => getParsedValue(value),
  },
  {
    title: "Updated at",
    dataIndex: "updatedAt",
    key: "updatedAt",
    width: 180,
    sorter: true,
    render: (date: string) =>
      dateTransform({
        date,
        format: TABLE_DATE,
      }),
  },
];
